import React__default from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import Profile from './Profile.js';

const ProfileContainer = ()=>{
    const { isAABEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React__default.createElement(Profile, {
        isAABEnabled: isAABEnabled
    });
};
var ProfileContainer$1 = ProfileContainer;

export { ProfileContainer$1 as default };
//# sourceMappingURL=ProfileContainer.js.map
